<template lang="pug">
div
  patient-history-view-details-diagnosis(:selectedHistory="selectedHistory")
  v-divider.my-6
  patient-history-view-details-medication(ref="viewDetailsMedication" :parentRegistration="parentRegistration" :selectedHistory="selectedHistory" :loading="isLoading" readonly)
  v-divider.my-6
  patient-history-view-details-services(ref="viewDetailsServices" :parentRegistration="parentRegistration" :selectedHistory="selectedHistory" :loading="isLoading" readonly)
  v-divider.my-6
  patient-history-view-details-documents(ref="viewDetailsDocuments" :selectedHistory="selectedHistory" :loading="isLoading" readonly)
</template>

<script>
import PatientHistoryViewDetailsDiagnosis from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsDiagnosis.vue'
import PatientHistoryViewDetailsMedication from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsMedication.vue'
import PatientHistoryViewDetailsServices from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsServices.vue'
import PatientHistoryViewDetailsDocuments from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsDocuments.vue'

export default {
  components: {
    PatientHistoryViewDetailsDiagnosis, PatientHistoryViewDetailsMedication, PatientHistoryViewDetailsServices, PatientHistoryViewDetailsDocuments
  },
  props: {
    selectedHistory: {
      type: Object,
      required: true
    },
    parentRegistration: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      isLoading: null
    }
  },
}
</script>

<style lang="scss" scoped>
</style>